import { useGraphCtx } from '@mi-front/core';
import { TimestampedThumbnail } from './types';
import { useThumbnailLayoutV2 } from './useThumbnailLayoutV2';

interface Props {
  thumbHeight: number;
  thumbnails: TimestampedThumbnail[];
}

/**
 * Time-aligned thumbnail filmstrip. Each frame is placed at scale(segment.startTs)
 * with width derived from sprite aspect ratio, avoiding horizontal clipping.
 */
export function ThumbnailsRollV2({ thumbHeight, thumbnails }: Props) {
  const { scale, width: containerWidth } = useGraphCtx();

  const thumbnailLayouts = useThumbnailLayoutV2({
    thumbnails,
    scale,
    thumbHeight,
    containerWidth,
  });

  if (!containerWidth) {
    return null;
  }

  return (
    <>
      {thumbnailLayouts.map(({ thumbnail, width, x, spriteWidth, spriteHeight }) => (
        <svg
          key={`${thumbnail.segmentId}-${thumbnail.startTs}`}
          width={width}
          height={thumbHeight}
          x={x}
        >
          <foreignObject width={width} height={thumbHeight} x={0} y={0}>
            <div
              style={{
                width: `${width}px`,
                height: `${thumbHeight}px`,
                backgroundImage: `url(${thumbnail.thumbnailUrl})`,
                backgroundSize: `${spriteWidth}px ${spriteHeight}px`,
                backgroundPosition: '0px 0px',
                backgroundRepeat: 'no-repeat',
                imageRendering: 'auto',
              }}
            />
          </foreignObject>
        </svg>
      ))}
    </>
  );
}
